<template>
	<base-form class="password-forgot-form">
		<template #header>
			<h2 class="password-forgot-form__title">
				Did you forget
				<br />
				your password?
			</h2>

			<p class="password-forgot-form__description">
				We’ll send you a link where you’ll be able
				<span><br /></span>
				to set a new password for your account.
			</p>
		</template>

		<form-element v-bind="{ errors, model, loading }" @submit="onSubmit">
			<form-item label="E-mail" :name="'email'" :rules="[required, email]">
				<input
					v-model="model.email"
					class="password-forgot-form__input"
					name="email"
					type="email"
					autocomplete="login-email"
				/>
			</form-item>

			<template #buttons>
				<router-link :to="{ name: 'login' }" class="link">Back to login</router-link>

				<base-button secondary type="submit" v-bind="{ loading }">Submit</base-button>
			</template>
		</form-element>
	</base-form>
</template>

<script lang="ts">
import { Dictionary } from 'lodash';
import { defineComponent, PropType } from 'vue';

import FormElement from '@/components/form/FormElement.vue';
import FormItem from '@/components/form/FormItem.vue';
import { email, required } from '@/tools/validation';

export default defineComponent({
	components: {
		FormElement,
		FormItem,
	},

	props: {
		loading: {
			type: Boolean,
			default: false,
		},

		errors: {
			type: Object as PropType<Dictionary<string[]>>,
			default: () => ({}),
		},
	},

	emits: ['submit'],

	data() {
		return {
			model: {
				email: '',
			},
		};
	},

	methods: {
		email,
		required,

		onSubmit() {
			const { email } = this.model;

			this.$emit('submit', {
				email,
			});
		},
	},
});
</script>

<style lang="scss">
.password-forgot-form {
	color: $color-light;

	&__title {
		@include heading-1;
	}

	&__description {
		margin: 2.4rem 0 0;
		font-size: 1.8rem;

		span {
			@include max-md-and-portrait {
				display: none;
			}
		}
	}

	.form-item {
		label {
			color: inherit;
		}

		input {
			&,
			&:focus,
			&:-webkit-autofill,
			&:-webkit-autofill:active,
			&:-webkit-autofill:hover,
			&:-webkit-autofill:focus {
				color: $color-dark !important;
				font-size: $font-size-input;
				background-color: $color-light !important;
			}
		}
	}

	.form-element__buttons {
		@include max-lg-and-portrait {
			margin-top: 4.4rem;
		}
	}
}
</style>
